import * as Immutable from "immutable";
import Direction from "./Direction";
export default class SortConfig {
  constructor(type, field, direction) {
    this._value = { type, field, direction };
  }
  get type() {
    return this._value.type;
  }
  get field() {
    return this._value.field;
  }
  get direction() {
    return this._value.direction;
  }
  toJSON() {
    const { type, field, direction } = this._value;
    return {
      type,
      field,
      direction
    };
  }
  static fromJSON(value) {
    const { type, field, direction } = value;
    return new Builder().type(type).field(field).direction(Direction.fromJSON(direction)).build();
  }
  static registerSubtype(type, implementingClass) {
    this.__registrations[type.toLowerCase()] = implementingClass;
  }
  static fromSeries(series) {
    return new Builder().type(this.SERIES_TYPE).field(series.function).direction(Direction.Descending).build();
  }
  toBuilder() {
    const { type, field, direction } = this._value;
    return new Builder(Immutable.Map({ type, field, direction }));
  }
}
SortConfig.PIVOT_TYPE = "pivot";
SortConfig.SERIES_TYPE = "series";
SortConfig.__registrations = {};
export class Builder {
  constructor(value = Immutable.Map()) {
    this.value = value;
  }
  type(value) {
    return new Builder(this.value.set("type", value));
  }
  field(value) {
    return new Builder(this.value.set("field", value));
  }
  direction(value) {
    return new Builder(this.value.set("direction", value));
  }
  build() {
    const { type, field, direction } = this.value.toObject();
    return new SortConfig(type, field, direction);
  }
}
